
import { InstrumentAmountDTO } from "../../openapi-generated-client";
import "./instrumentation.css";
import InstrumentDisplay from "./instrumentDisplay";

interface InstrumentationProps {
    instruments: InstrumentAmountDTO[];
    orchestralInstruments?: InstrumentAmountDTO[];
}

export default function Instrumentation(props: InstrumentationProps) {

    return <ul className="instrumentation">
        {props.instruments.map(function (current){
            var amount = current.amount;
            return <InstrumentDisplay key={current.instrument} instrument={current.instrument} amount={amount!}/>;
        })}
        {props.orchestralInstruments ? props.orchestralInstruments.map(function (current){
            var amount = current.amount;
            return <InstrumentDisplay key={current.instrument} className="orchestral-instrument" instrument={current.instrument} amount={amount!}/>;
        }) : <></>}
    </ul>;

}